module.exports = __webpack_public_path__ + "img/tuoyuan.ed93b28d.png";